import {Button, message} from "antd";
import {notifyCustomErrors} from "../component/gammaviewer/utils/display.notification";
import {ErrorMessage, ErrorTypes} from "../utils/const";

export const error_manager = (msg, error, showDuration = 5) => {
	console.error("Error: ", error);
	if (error?.data?.status === 440) {
		console.error("Error: ", error?.data);
		return;
	}
	if (window.location.pathname?.includes('/gamma')) {
		notifyCustomErrors(error, msg, showDuration * 1000)
	} else {
		if (error?.message === ErrorTypes.NETWORK_MSG || error?.code === ErrorTypes.NETWORK_CODE) {
			console.error(ErrorMessage.NETWORK_ERROR);
		} else if (error?.response?.status === 504) {
			message.error(<ErrorMessageWithReload content={ErrorMessage.SERVER_ERROR}/>, 0);
		} else if (error?.response?.status === 403) {
			message.error(ErrorMessage.UNAUTHORIZED_ERROR, showDuration);
		} else if (error?.response?.status === 502) {
			message.error(<ErrorMessageWithReload content={ErrorMessage.BAD_GATEWAY_ERROR}/>, 0)
		} else if ((error?.response?.status === 404 && (error?.response?.data.includes("nginx")) &&
			error?.response?.data.includes(ErrorTypes.NGINX_ERROR)) || error?.response?.status === 500) {
			message.error(<ErrorMessageWithReload content={ErrorMessage.NGINX_ERROR}/>, 0)
		} else {
			if (!msg) {
				if (typeof (error?.response?.data) === "object" && error.response.data.hasOwnProperty('ERRCODE')
					&& error.response.data.hasOwnProperty('ERRMSG')) {
					msg = "ERR - " + error.response.data['ERRCODE'] + " : " + error.response.data['ERRMSG'];
				} else {
					msg = error?.response?.data || error?.response?.data?.message || error?.message || "Request failed";
					if (msg.includes(`<html>`)) msg = "Request failed";
				}
			}
			message.error(msg, showDuration);
		}
	}
}

const ErrorMessageWithReload = ({content}) => (
	<>
		{content}
		<Button type="danger" size="small" onClick={() => window.location.reload()} style={{marginLeft: '1em'}}>
			Reload
		</Button>
	</>
);